export default __webpack_public_path__ + "static/media/Icon7.cd5b43eb.png";